import React, { useState, useEffect } from 'react';

// 실시간 카운트다운 — API의 timeRemaining.totalSeconds로 초기화 후 로컬 1초 감소
function AuctionCountdown(props){
  var tr=props.timeRemaining||{};
  var onExpired=props.onExpired;
  var size=props.size||'md';
  var showIcon=props.showIcon!==false;
  var initialSec=tr.totalSeconds||0;
  var[seconds,setSeconds]=useState(initialSec);
  var[blink,setBlink]=useState(true);

  // 부모가 props.timeRemaining을 교체하면 재초기화
  useEffect(function(){
    setSeconds(tr.totalSeconds||0);
  },[tr.totalSeconds]);

  // 매초 감소
  useEffect(function(){
    if(seconds<=0)return;
    var timer=setInterval(function(){
      setSeconds(function(prev){
        if(prev<=1){
          clearInterval(timer);
          if(onExpired)setTimeout(onExpired,0);
          return 0;
        }
        return prev-1;
      });
    },1000);
    return function(){clearInterval(timer)};
  },[seconds>0]);

  // urgency 재계산 (서버값 신뢰 안 하고 로컬에서 다시 — 시간 흐름 반영)
  var urgency;
  if(seconds<=0)urgency='ended';
  else if(seconds<=600)urgency='critical';
  else if(seconds<=3600)urgency='warning';
  else urgency='normal';

  // critical 시 깜빡임
  useEffect(function(){
    if(urgency!=='critical')return;
    var i=setInterval(function(){setBlink(function(b){return !b})},500);
    return function(){clearInterval(i)};
  },[urgency]);

  var pad=function(n){return n<10?'0'+n:String(n)};
  var display;
  if(seconds<=0){display='마감'}
  else{
    var h=Math.floor(seconds/3600);
    var m=Math.floor((seconds%3600)/60);
    var s=seconds%60;
    display=pad(h)+':'+pad(m)+':'+pad(s);
  }

  var color=urgency==='critical'?'#ef4444':urgency==='warning'?'#f59e0b':urgency==='ended'?'#94a3b8':'#475569';
  var fontSize=size==='lg'?16:size==='md'?13:11;
  var weight=urgency==='critical'?800:700;
  var opacity=urgency==='critical'&&!blink?0.45:1;

  return (
    <span style={{color:color,fontSize:fontSize,fontWeight:weight,fontFamily:'monospace',display:'inline-flex',alignItems:'center',gap:3,opacity:opacity,transition:'opacity 0.3s'}}>
      {showIcon&&<span style={{fontSize:fontSize-1}}>⏱</span>}
      <span>{display}</span>
    </span>
  );
}

export default AuctionCountdown;
